import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNil } from 'lodash';
import { ApiService } from './api.service';
import { UserApplicationsDto } from '@app/shared/models/dashboard/user-applications';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserApplicationService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getByUserId(userId: string): Observable<UserApplicationsDto> {
    return this.http.get<UserApplicationsDto>(this.endpoint(`api`, `userapplications`, `users`, `${userId}`));
  }

  public save(userApplication: UserApplicationsDto): Observable<UserApplicationsDto> {
    return isNil(userApplication.id)
      ? this.http.post<UserApplicationsDto>(this.endpoint(`api`, `userapplications`), userApplication)
      : this.http.put<UserApplicationsDto>(this.endpoint(`api`, `userapplications`), userApplication);
  }
}
